import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./DiscardChangesDialog.css";
import { LoadingButton } from "@mui/lab";

const DiscardChangesDialog = ({
  title,
  text,
  user,
  createBtn,
  open,
  handleCreate,
  handleClose,
  btnLoading,
  // setBtnLoading,
}) => {
  const handlegoBack = () => {
    handleCreate();
  };

  const handleCancel = () => {
    handleClose(false);
    // setBtnLoading(false);
  };

  return (
    <div>
      <Dialog onClose={handleClose} open={open} maxWidth="xs" fullWidth>
        <DialogTitle>
          <Typography className="discardChanges-title">{title}</Typography>
        </DialogTitle>
        <DialogContent>
          <Box className="discardChanges-textMain">
            <Typography variant="p" className="discardChanges-text">
              {text}{" "}
              <span style={{ fontWeight: "600" }}>
                {user !== undefined && user !== "" && user}
              </span>
            </Typography>
          </Box>
        </DialogContent>
        <Box className="discardChanges-BtnMain">
          <Button
            onClick={handleCancel}
            variant="outlined"
            className="discardChanges-BtnMain-cancleBtn"
          >
            Cancel
          </Button>
          <LoadingButton
            onClick={handlegoBack}
            variant="contained"
            color="primary"
            loading={btnLoading !== undefined && btnLoading ? true : false}
          >
            {createBtn}
          </LoadingButton>
        </Box>
      </Dialog>
    </div>
  );
};

export default DiscardChangesDialog;
